module.exports = __webpack_public_path__ + "img/normalmap.8135b487.jpg";